import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";

/*! Provides core utilities for the working with both versions of the ESRI JSAPI.
 *
 * @ai360/core v27.3.0 (https://bitbucket.org/agvanceskyteam/ai360.client.core.git)
 * SSI DO NOT COPY!!!
 */
import { a4 as e, R as t, b as r, Q as n } from "./api/rec.js";
import { v4 as s } from "uuid";

var a = r("nonfieldfeature", "v1.0"),
    apiFeaturesToNormalizedFeatures = function apiFeaturesToNormalizedFeatures(t) {
  if (!t) return [];
  return t.map(function (t) {
    var r = t.geometries.map(function (t) {
      var r = e.geometryFromGeoJson(t.shape, e.getSpatialReference(3857));
      return Object.assign(new NonFieldFeatureGeometry(), _objectSpread(_objectSpread({}, t), {}, {
        shape: r
      }));
    });
    return Object.assign(new NonFieldFeature(), _objectSpread(_objectSpread({}, t), {}, {
      geometries: r
    }));
  });
},
    fetchFeaturesForUser = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var e, r, s;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            e = new n();
            e.append("spatialReference", "wgs84".toString()), e.append("active", "true");
            r = a("", e.toString());
            _context.next = 5;
            return t.get(r);

          case 5:
            s = _context.sent;
            return _context.abrupt("return", apiFeaturesToNormalizedFeatures(s.results));

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFeaturesForUser() {
    return _ref.apply(this, arguments);
  };
}();

var NonFieldFeature = /*#__PURE__*/function () {
  function NonFieldFeature() {
    _classCallCheck(this, NonFieldFeature);

    this.id = s(), this.customerId = null, this.fieldId = null, this.customerName = "", this.name = "", this.description = "", this.type = "", this.isPrivate = !1, this.geometries = [], this.useExtent = !1, this.active = !0;
  }

  _createClass(NonFieldFeature, [{
    key: "clone",
    value: function clone() {
      var e = this.geometries.map(function (e) {
        return e.clone();
      });
      return Object.assign(new NonFieldFeature(), _objectSpread(_objectSpread({}, this), {}, {
        geometries: e
      }));
    }
  }]);

  return NonFieldFeature;
}();

var NonFieldFeatureGeometry = /*#__PURE__*/function () {
  function NonFieldFeatureGeometry() {
    _classCallCheck(this, NonFieldFeatureGeometry);

    this.id = s();
  }

  _createClass(NonFieldFeatureGeometry, [{
    key: "clone",
    value: function clone() {
      var t = e.clone(this.shape);
      return Object.assign(new NonFieldFeatureGeometry(), _objectSpread(_objectSpread({}, this), {}, {
        shape: t
      }));
    }
  }]);

  return NonFieldFeatureGeometry;
}();

var o = Object.freeze({
  __proto__: null,
  esriJsonFeaturesToNormalizedFeatures: function esriJsonFeaturesToNormalizedFeatures(t) {
    if (!t) return [];
    return t.map(function (t) {
      var r = t.geometries.map(function (t) {
        var r = e.geometryFromEsriJson(t.shape);
        return Object.assign(new NonFieldFeatureGeometry(), _objectSpread(_objectSpread({}, t), {}, {
          shape: r
        }));
      });
      return Object.assign(new NonFieldFeature(), _objectSpread(_objectSpread({}, t), {}, {
        geometries: r
      }));
    });
  },
  fetchFeaturesForUser: fetchFeaturesForUser,
  fetchFeaturesForCustomer: function () {
    var _fetchFeaturesForCustomer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
      var r,
          s,
          o,
          i,
          _args2 = arguments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              r = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : null;
              s = new n();
              s.append("customer", e), s.append("spatialReference", "wgs84".toString()), s.append("active", "true");
              o = a("", s.toString());
              _context2.next = 6;
              return t.get(o, null, r);

            case 6:
              i = _context2.sent;
              return _context2.abrupt("return", apiFeaturesToNormalizedFeatures(i.results));

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function fetchFeaturesForCustomer(_x) {
      return _fetchFeaturesForCustomer.apply(this, arguments);
    }

    return fetchFeaturesForCustomer;
  }(),
  fetchFeaturesForIds: function () {
    var _fetchFeaturesForIds = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
      var r, s, o;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              r = new n();
              r.append("feature", e), r.append("spatialReference", "wgs84".toString()), r.append("active", "true");
              s = a("", r.toString());
              _context3.next = 5;
              return t.get(s);

            case 5:
              o = _context3.sent;
              return _context3.abrupt("return", apiFeaturesToNormalizedFeatures(o.results));

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function fetchFeaturesForIds(_x2) {
      return _fetchFeaturesForIds.apply(this, arguments);
    }

    return fetchFeaturesForIds;
  }(),
  saveFeature: function saveFeature(r) {
    var s = new n();
    s.append("spatialReference", "webMercator".toString());
    var o = a(r.id, s.toString());
    return t.put(o, function (t) {
      var r = t.geometries.map(function (t) {
        var r = e.geoJsonFromGeometry(t.shape, e.getSpatialReference(3857));
        return Object.assign(new NonFieldFeatureGeometry(), _objectSpread(_objectSpread({}, t), {}, {
          shape: r
        }));
      });
      return Object.assign(new NonFieldFeature(), _objectSpread(_objectSpread({}, t), {}, {
        geometries: r
      }));
    }(r));
  },
  deleteFeature: function deleteFeature(e) {
    var r = a(e);
    return t.delete(r, void 0);
  },
  patchFeature: function patchFeature(e) {
    return t.patch(a(e + "/active", null), {
      active: !1
    }, "application/json", null);
  },
  NonFieldFeature: NonFieldFeature,
  NonFieldFeatureGeometry: NonFieldFeatureGeometry
});
export { NonFieldFeatureGeometry as N, fetchFeaturesForUser as f, o as n };